import { LazyLanguageSelector } from "@faire/help-center-self-serve/components/LanguageSelector/LazyLanguageSelector";
import { isMobileApp } from "@faire/help-center-utils/lib/isMobileApp";
import { availableLanguageSelectorLocales } from "@faire/help-center-utils/serialized-data/availableLanguageSelectorLocales";
import { browserLevelLanguage, browserLevelLocaleKey } from "@faire/help-center-utils/serialized-data/getLocale";
import { getSessionCountry } from "@faire/help-center-utils/serialized-data/getSessionCountry";
import { getUserToken } from "@faire/help-center-utils/serialized-data/getUser";
import { getSettingHelpCenterChatAvailableLocales } from "@faire/help-center-utils/settings/getSettingHelpCenterChatAvailableLocales";
import { getSettingHelpCenterEnableLocales } from "@faire/help-center-utils/settings/getSettingHelpCenterEnableLocales";
import { getSettingSelfServeShowAllLanguage } from "@faire/help-center-utils/settings/getSettingSelfServeShowAllLanguage";
import { trackCxFoundationsBackToHelpCenterClick } from "@faire/web-api/events/cxFoundations/click/backToHelpCenter";
import { trackCxFoundationsBackToHelpCenterWithBrandOrderClick } from "@faire/web-api/events/cxFoundations/click/backToHelpCenterWithBrandOrder";
import home from "@faire/web-api/routes/support";
import { FaireLogo } from "@faire/web/slate/icons/FaireLogo";
import { Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { clearLocalStorage } from "../../utils/localStorage";
export var SelfServeHeader = function SelfServeHeader(_ref) {
  var _getUserToken;
  var issueType = _ref.issueType,
    selectedBrandOrder = _ref.selectedBrandOrder;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var userToken = (_getUserToken = getUserToken()) !== null && _getUserToken !== void 0 ? _getUserToken : "";
  var trackEvents = function trackEvents() {
    var _selectedBrandOrder$b, _selectedBrandOrder$b2;
    trackCxFoundationsBackToHelpCenterClick(userToken, issueType, pathname);
    trackCxFoundationsBackToHelpCenterWithBrandOrderClick(userToken, (_selectedBrandOrder$b = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : (_selectedBrandOrder$b2 = selectedBrandOrder.brand_order) === null || _selectedBrandOrder$b2 === void 0 ? void 0 : _selectedBrandOrder$b2.token) !== null && _selectedBrandOrder$b !== void 0 ? _selectedBrandOrder$b : "");
  };
  var clearStorageAndTrackEvent = function clearStorageAndTrackEvent() {
    clearLocalStorage();
    trackEvents();
  };
  var renderLanguageSelector = function renderLanguageSelector() {
    if (!getSettingHelpCenterEnableLocales()) {
      return null;
    }
    if (isMobileApp()) {
      return null;
    }
    return /*#__PURE__*/React.createElement(LanguageSelectorWrapper, null, /*#__PURE__*/React.createElement(LazyLanguageSelector, {
      eventKey: "help-center-self-serve-top",
      position: "downLeft",
      browserLanguage: browserLevelLanguage(),
      browserLocale: browserLevelLocaleKey(),
      availableLocales: getSettingSelfServeShowAllLanguage() ? availableLanguageSelectorLocales : getSettingHelpCenterChatAvailableLocales(),
      assignLocalizedUrl: true,
      sessionCountry: getSessionCountry()
    }));
  };
  return /*#__PURE__*/React.createElement(SelfServeHeaderWrapper, null, /*#__PURE__*/React.createElement(FaireLogoWrapper, null, /*#__PURE__*/React.createElement(Link, {
    to: home(),
    onClick: clearStorageAndTrackEvent
  }, /*#__PURE__*/React.createElement(FaireLogo, null))), renderLanguageSelector());
};
var SelfServeHeaderWrapper = styled(Row).attrs({
  justify: "flex-start",
  align: "center"
}).withConfig({
  displayName: "SelfServeHeader__SelfServeHeaderWrapper"
})(["height:60px;padding:32px;position:relative;"]);
var FaireLogoWrapper = styled.div.withConfig({
  displayName: "SelfServeHeader__FaireLogoWrapper"
})(["position:absolute;margin:0;left:50%;top:50%;transform:translate(-50%,-50%);"]);
var LanguageSelectorWrapper = styled.div.withConfig({
  displayName: "SelfServeHeader__LanguageSelectorWrapper"
})(["position:absolute;right:", ";top:50%;transform:translateY(-50%);z-index:2;"], getSpacing("3x"));